module.exports = __webpack_public_path__ + "img/checking.700e5f83.png";